import Config from '@config';
import { createApi } from '@reduxjs/toolkit/query/react';

import { CACHE_EXPIRATION_TIME_REFERENCE_BOOK } from '@/features/constants';
import axiosBaseQuery from '@/utils/axiosBaseQuery';

import { ViolationDecision } from './types';

export const violationDecisionsApi = createApi({
  reducerPath: 'violationDecisionsApi',
  baseQuery: axiosBaseQuery({
    baseUrl: Config.VITE_API_URL + '/violation-decisions',
  }),
  keepUnusedDataFor: CACHE_EXPIRATION_TIME_REFERENCE_BOOK,
  endpoints: builder => ({
    getViolationDecisions: builder.query<ViolationDecision[], void>({
      query: () => ({
        url: '/',
      }),
    }),
  }),
});

export const { useGetViolationDecisionsQuery } = violationDecisionsApi;
